import {combineReducers} from '@reduxjs/toolkit';

import {userAuditLogStateSlice} from './slices/user-audit-log-state.slice';
import {userAuditLogSlice} from './slices/user-audit-log.slice';

export const userAuditLogReducer = combineReducers({
    events: userAuditLogSlice.reducer,
    state: userAuditLogStateSlice.reducer,
});
